import "../../assets/css/login.css";
import logo from "../../assets/images/bna-logo-white.png";
import axios from "axios";
import { LOGIN } from "../../routes/routes";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { ValidationMessage } from "../../components/Utils";

import { useApplicationContext } from "../../context/ApplicationContext";

const LoginPage = () => {
  const { setUserAndPermissions } = useApplicationContext();
  // ## State Variables
  const [type, setType] = useState("password");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  // Navigation
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  /**
   * @API call for Login Authentication
   */
  const submit = (e) => {
    e.preventDefault();
    setBtnDisabled(true);
    axios
      .post(LOGIN, form)
      .then((response) => {
        if (response?.data?.success && response?.data?.code === 200) {
          const userData = response.data.data;
          const userPermissions = response.data.data.permissions;
          
          localStorage.setItem("token", userData.token);
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem('permissions', JSON.stringify(userPermissions));
          
          setUserAndPermissions(userData, userPermissions);
          
          toast.success(response.data.msg);
          navigate(from, { replace: true });
        }
      })
      .catch((error) => {
        if (
          !error?.response?.data?.success &&
          error?.response?.status === 422
        ) {
          setErrors(error?.response?.data?.error);
          toast.error(error?.response?.data?.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="login-pg">
        <div className="container-fluid p-0">
          <div className="row align-items-center g-0 m-0">
            <div className="col-lg-7 d-none d-lg-block p-0 bg-wrappers">
              <div className="login-bg"></div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 p-0">
              <div className="login-wrappers">
                <div className="login-container">
                  <div className="login-content">
                    {/* <img src={logo} className="login-logo" alt="" /> */}
                    <img src={logo} className="login-logo-one" alt="" />
                  </div>
                  <form
                    id="formAuthentication"
                    className="mb-3"
                    onSubmit={submit}
                    method="POST"
                    autoComplete="off"
                    autoFocus="off"
                  >
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label theme-label">
                        Email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        autoFocus
                        onChange={(e) =>
                          setForm({ ...form, email: e.target.value })
                        }
                      />
                      <ValidationMessage error={errors} name="email" />
                    </div>
                    <div className="mb-3 form-password-toggle login-password">
                      <div className="d-flex justify-content-between">
                        <label
                          className="form-label theme-label"
                          htmlFor="password"
                        >
                          Password
                        </label>
                      </div>
                      <div className="input-group input-group-merge">
                        <input
                          type={type}
                          id="password"
                          className="form-control"
                          name="password"
                          placeholder="********"
                          aria-describedby="basic-default-password"
                          onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                          }
                        />

                        {type === "password" ? (
                          <span
                            className="input-group-text cursor-pointer"
                            id="basic-default-password"
                            onClick={() => setType("text")}
                          >
                            <i className="bx bx-hide"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text cursor-pointer"
                            id="basic-default-password"
                            onClick={() => setType("password")}
                          >
                            <i className="bx bx-show"></i>
                          </span>
                        )}
                      </div>
                      <ValidationMessage error={errors} name="password" />
                    </div>
                    <div className="mt-5 mb-3">
                      <button
                        disabled={btnDisabled}
                        className="btn btn-primary login-submit d-grid w-100"
                        type="submit"
                      >
                        Sign in
                      </button>
                    </div>
                  </form>
                  <div className="login-dev text-center">
                    <a
                      href="https://www.innoblitz.global/"
                      target="_blank"
                      style={{
                        color: "#420203",
                        float: "none",
                        display: "inline-block",
                      }}
                    >
                      Design & Developed By &nbsp;
                      <span
                        style={{
                          textDecoration: "underline",
                          fontWeight: "500",
                        }}
                      >
                        Innoblitz Technologies and Systems Pvt Ltd.
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
      </div>
    </div>
  );
};

export default LoginPage;
